import React from "react";
import { Button, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Person } from "@mui/icons-material";
import { useAppSelector } from "../../hooks/useRedux";
import AccountPopover from "./AccountPopover";
import usePopover from "../../hooks/usePopover";

const AccountButton = () => {
  const { token } = useAppSelector((state) => state.auth);

  const naviagte = useNavigate();
  const handleLogin = () => naviagte("/login");

  const { open, handleOpen, handleClose, anchorRef } = usePopover();

  return token ? (
    <>
      <IconButton onClick={handleOpen} color="primary" ref={anchorRef}>
        <Person />
      </IconButton>
      <AccountPopover open={open} onClose={handleClose} anchorEl={anchorRef.current} />
    </>
  ) : (
    <Button variant="contained" onClick={handleLogin}>
      Login
    </Button>
  );
};

export default AccountButton;
